<div class="new-agent-container">
  <div class="title">
    <button class="cancel" (click)="goBack()">
      <img src="assets/icones/close_icon.svg" alt="">
    </button>
    <span>{{ 'agent.new_agent' | translate }}</span>
  </div>
  <div class="steps">
    <div
      [id]="'step-'+$idx"
      class="step"
      *ngFor="let step of creationSteps; let $idx = index; let isLast = last"
      [class.active]="step.active"
      [class.completed]="step.completed && !step.active"
      (click)="goToStep($idx)"
    >
      <span class="step-icon"></span>
      <span class="step-label">{{ step.label | translate }}</span>
      <div class="seperator" *ngIf="!isLast">
        <img src="assets/icones/chevron_right.svg" alt="">
      </div>
    </div>
  </div>
  <div class="step-content">
    <ng-container [ngTemplateOutlet]="currentStepIndex === 0 ? details : currentStepIndex === 1 ? portfolio : catalogs"></ng-container>
  </div>
</div>

<ng-template #details>
  <app-new-agent-details (nextStep)="next($event)" [agent]="agentPayload"></app-new-agent-details>
</ng-template>

<ng-template #portfolio>
  <app-new-agent-portfolio (nextStep)="next($event)" (previousStep)="previous($event)" [agent]="agentPayload"></app-new-agent-portfolio>
</ng-template>

<ng-template #catalogs>
  <app-new-agent-catalogs (nextStep)="next($event)" (previousStep)="previous($event)" [agent]="agentPayload"></app-new-agent-catalogs>
</ng-template>
